import React from 'react';


// import unset from 'unset-value';
import './NodePanel.scss';
import { NodeInterface, QuestInterface } from '@swivl-mono/types';



import _ from 'lodash';
import { warn } from '@swivl-mono/helpers';
import { ReorderHelper } from '../../../../Models/Quests/Helpers/ReorderHelper';


export interface NodePanelProps {
  updateNode(node: NodeInterface, originalNode: NodeInterface, forceUpdate?: boolean): void
  node: NodeInterface
  selectedQuest?: QuestInterface
  deleteNode?(node: NodeInterface): void
  canEdit: boolean
}
export default class NodePanel extends React.Component<NodePanelProps> {
  deleteNode: any
  constructor(props: NodePanelProps) {
    super(props);
    this.onChange = this.onChange.bind(this)
    this.onChangeSwitch = this.onChangeSwitch.bind(this)
    this.onChangeUpdateAndRedraw = this.onChangeUpdateAndRedraw.bind(this)
    this.onChangeNumber = this.onChangeNumber.bind(this)

    this.onChangeSave = this.onChangeSave.bind(this)
    this.onChangeFindMean = this.onChangeFindMean.bind(this)
    this.onChangeCalculateOdds = this.onChangeCalculateOdds.bind(this)
    this.deleteValue = this.deleteValue.bind(this)
    this.moveItemInArray = this.moveItemInArray.bind(this)
    this.addItemToArray = this.addItemToArray.bind(this)
    this.deleteNode = this.props.deleteNode

  }

  componentWillMount() {
    // this.props.unsetAuxPanel()
  }

  onChange(event: any) {
    if (!this.props.canEdit) { return; }
    const target = event.target;
    const value = (target.type && target.type === 'checkbox') ? target.checked : target.value;
    const name = target.name;
    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    this.props.updateNode(node, this.props.node)
  }

  onChangeSwitch(name: string, value: any) {
    if (!this.props.canEdit) { return; }

    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    this.props.updateNode(node, this.props.node)
  }

  onChangeUpdateAndRedraw(event: any) {
    if (!this.props.canEdit) { return; }

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    this.props.updateNode(node, this.props.node, true)
  }

  onChangeNumber(event: any) {
    if (!this.props.canEdit) { return; }

    const target = event.target;
    var value = (target.type && target.type === 'checkbox') ? target.checked : target.value;
    if (isNaN(value)) { warn("Not a number"); return; }
    if (typeof value == "string") { // It's a string. Converting...
      value = +value;
    }
    const name = target.name;
    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    this.props.updateNode(node, this.props.node, true)
  }

  onChangeSave(event: any) {
    if (!this.props.canEdit) { return; }

    const target = event.target;
    const value = target.value;
    const name = target.name;
    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    if (name == "saveTo" && value == this.props.node.saveValue) { _.set(node, name, ""); }
    if (name == "saveValue" && value == this.props.node.saveTo) { _.set(node, name, ""); }
    this.props.updateNode(node, this.props.node)
  }

  onChangeFindMean() {
    if (!this.props.canEdit) { return; }

    let node = JSON.parse(JSON.stringify(this.props.node));
    var mean = Math.floor((parseInt(this.props.node.min) + parseInt(this.props.node.max)) / 2);
    _.set(node, "default", mean);
    this.props.updateNode(node, this.props.node);
  }

  onChangeCalculateOdds(event: any) {
    if (!this.props.canEdit) { return; }

    const value = parseInt(event.target.value);
    const name = event.target.name;
    let node = JSON.parse(JSON.stringify(this.props.node));
    _.set(node, name, value);
    this.props.updateNode(node, this.props.node, true);
    var total = value;
    var findSum = node.paths.map(function (item: any) {
      if (item.id !== event.target.id) { total += item.probability; }
    });
    if (total > 100) {
      var minusThis = total - 100;
      var takeThis = (name == "paths.0.probability") ? value : this.props.node.paths[0].probability;
      var finalValue = takeThis - minusThis;
      _.set(node, "paths.0.probability", finalValue);
      this.props.updateNode(node, this.props.node, true);
    }
  }



  deleteValue(arrayName: any, index: any) {
    if (!this.props.canEdit) { return; }

    let node = JSON.parse(JSON.stringify(this.props.node));
    let arr = _.get(node, arrayName)
    arr.splice(index, 1);
    _.set(node, arrayName, arr)
    this.props.updateNode(node, this.props.node, true)
  }

  moveItemInArray(arrayName: any, itemIndex: any, up?: boolean) {
    if (!this.props.canEdit) { return; }

    let node = JSON.parse(JSON.stringify(this.props.node));
    let arr = _.get(node, arrayName)
    if (!up && itemIndex == 0) { return; /* First */ }
    if (up && itemIndex + 1 >= arr.length) { return; /* Last */ }
    let swapIndex = (up) ? itemIndex + 1 : itemIndex - 1

    arr = ReorderHelper.reorder(arr, itemIndex, swapIndex)
    // arr = Helper.immutablySwapItems(arr, itemIndex, swapIndex)
    _.set(node, arrayName, arr)
    this.props.updateNode(node, this.props.node, true)

  }

  addItemToArray(item: any, arrayName: string, forceRedraw?: boolean) {

    // addItemToArray(arrayName:any, itemIndex:any, forceRedraw?:boolean, item?:any) {
    if (!this.props.canEdit) { return; }

    let node = JSON.parse(JSON.stringify(this.props.node));
    let arr = _.get(node, arrayName)
    if (!arr) { arr = [] }
    arr.push(item)

    _.set(node, arrayName, arr)
    this.props.updateNode(node, this.props.node, forceRedraw)
  }

  // deleteNode() {
  //   if (!this.props.canEdit) {return;}

  //   this.props.deleteNode(this.props.node)
  // }




  render() {
    return (<div></div>);
  }
};
